<template>        
<form @submit.prevent="submit()" class="form">
<div class="modal-container">
                <div class="modal-header">
                </div>
                <div class="modal-holder">
                <div class="content-holder">
                <div class="modal-body" v-for="component in model.dynamicUiData">
                  <div v-if = "component.displayType=='datefield'" :id=component.key>
                    <label class="form-label">
                      <span class="form-left">{{component.displayname}}</span>
                      <span class="form-right">   
                      <input type="date" v-model="form[component.key]"
                         :name=component.propertyName></span>
                      <span v-if = "component.required===1" class="mandatoryMark">*</span>   
                    </label>
                    <div class="validationMsg">{{errorMsg[component.key]}}</div>
                  </div>
                  <div v-if = "component.displayType=='number'" :id=component.key>
                    <label class="form-label">
                        <span class="form-left">{{component.displayname}}</span>
                        <span class="form-right">
                        <input type="number" :disabled="!component.iseditable"
                         v-model="form[component.key]"
                         :name=component.propertyName ></span>
                         <span v-if = "component.required===1" class="mandatoryMark">*</span>   
                    </label>
                    <div class="validationMsg">{{errorMsg[component.key]}}</div>
                  </div>
                  <div v-if = "component.displayType=='textarea'" :id=component.key>
                    <label class="form-label">
                        <span class="form-left">{{component.displayname}}</span>
                        <span class="form-right">
                        <textarea  rows="3" :disabled="!component.iseditable"
                         v-model="form[component.key]"
                         :name=component.propertyName ></textarea></span>
                         <span v-if = "component.required===1" class="mandatoryMark">*</span>   
                    </label>
                    <div class="validationMsg">{{errorMsg[component.key]}}</div>
                  </div>
                  <div v-if = "component.displayType=='textfield'" :id=component.key>
                    <label class="form-label">
                        <span class="form-left">{{component.displayname}}</span>
                        <span class="form-right">
                        <input type="text" :disabled="!component.iseditable"
                         v-model="form[component.key]"
                         :name=component.propertyName ></span>
                         <span v-if = "component.required===1" class="mandatoryMark">*</span>   
                    </label>
                    <div class="validationMsg">{{errorMsg[component.key]}}</div>
                  </div>
                  <div v-if = "component.displayType=='combobox'" :id=component.key>
                    <label class="form-label">
                       <span class="form-left">{{component.displayname}}</span>
                       <span class="form-right"><select  v-model="form[component.key]">
                          <option  v-for="listvalue in component.listvalues">{{listvalue.displayname}}</option>
                        </select></span>
                        <span v-if = "component.required===1" class="mandatoryMark">*</span>   
                    </label>
                    <div class="validationMsg">{{errorMsg[component.key]}}</div>
                  </div>
                  <div v-if = "component.displayType=='checkbox'" :id=component.key>
                    <label class="form-label">
                       
                       <span class="form-right-checkbox"><input type="checkbox" v-model="form[component.key]"></span>
                       <span class="form-left-check">{{component.displayname}}</span>
                       <span v-if = "component.required===1" class="mandatoryMark">*</span>   
                    </label>
                    <div class="validationMsg">{{errorMsg[component.key]}}</div>
                  </div>     
                </div>
                </div>
                <div class="notification">
                 <div class="validationMsg">{{validationMessage}}</div>
                 <div>Fields marked with <span class="mandatoryMarkText">*</span> are mandatory</div>
                </div>
                <div class="modal-footer">
                    <button type="button" v-bind:class="{ button: true }" @click="hideMetadataPopup()">
                      <i class="fa fa-times"></i>
                        cancel
                    </button>
                    <button type="submit" v-bind:class="{ button: true }" >
                      <i class="fa fa-paper-plane"></i>
                        submit
                    </button>
                </div>
              </div>  
                
            </div>
          </div>  
</form>          
</template>
<style>

/*Form popup*/

/** {
    box-sizing: border-box;
}
*/
.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    transition: opacity .3s ease;
}

.modal-container {
    width: 400px;
    margin: 75px auto;
    padding: 20px 30px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    font-family: Helvetica, Arial, sans-serif;
}

.modal-container textarea{
    resize: none;
    width: 100%;
}

.form-left{
  display:block
}

.form-right{
  width: 85%;
  display: inline-block;
}

.modal-header h3 {
    margin-top: 0;
}

.modal-body {
    margin: 20px 0;
}

.text-right {
    text-align: right;
}

.form-label {
    display: block;
}

.form-label > .form-control {
    margin-top: 0.5em;
}

.form-control {
    display: block;
    width: 100%;
    padding: 0.5em 1em;
    line-height: 1.5;
    border: 1px solid #ddd;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
.content-holder{
  max-height: 350px;
  overflow-x: hidden;
  overflow-y: auto;
}
.modal-footer{
  padding: 20px;
  text-align: center;
}
.mandatoryMark{
  color: red;
  margin: 8px;
}
.mandatoryMarkText{
  color: red;
}

.modal-body select,input[type="text"],input[type="number"],input[type="date"]{
  width:100%;
}

.notification{
  padding-top: 20px;
}

.validationMsg{
  font-style: italic;
  color: red;
  width: 85%;
  text-align: right;
}

.content-holder::-webkit-scrollbar {
    width: 7px;
}

/* Track */
.content-holder::-webkit-scrollbar-track {
    background: #f1f1f1; 
}
 
/* Handle */
.content-holder::-webkit-scrollbar-thumb {
    background: #888; 
}

/* Handle on hover */
.content-holder::-webkit-scrollbar-thumb:hover {
    background: #555; 
}

</style>
<script>
 import {ERROR_MSG} from '../../store/mutation-types'
 export default {
   props: ['model', 'dynamicMetadataPopupFlag'],
   data () {
     return {
       validationMessage: '',
       form: this.model.form,
       VALIDATION_MSG: {'email': 'not a valid email id', 'alphaNumeric': 'only alphabets and numbers allowed', 'alphabets': 'only alphabets allowed', 'numeric': 'Not a valid number!'},
       errorMsg: this.model.errorMessage
     }
   },
   methods: {
     hideMetadataPopup () {
       this.model.dynamicMetadataPopupFlag = false
       console.log(this.model)
     },
     validateForm (validationType, value) {
       var regex = ''
       if (validationType === 'email') {
         var emails = value.replace(/\s/g, '').split(',')
         regex = /^([a-zA-Z0-9_]+)@([a-zA-Z0-9_]+)\.([a-zA-Z]{2,5})$/
         for (var i = 0; i < emails.length; i++) {
           if (emails[i] !== '' && !regex.test(emails[i])) {
             return false
           }
         }
         return true
       } else if (validationType === 'alphaNumeric') {
         regex = /^[a-zA-Z0-9\s]+$/
         return regex.test(value)
       } else if (validationType === 'alphabets') {
         regex = /^[A-z\s]+$/
         return regex.test(value)
       } else if (validationType === 'numeric') {
         regex = /^\d+$/
         return regex.test(value)
       }
     },
     changeDateFormat (datevalue) {
       var today = new Date(datevalue)
       var dd = today.getDate()
       var mm = today.getMonth() + 1

       var yyyy = today.getFullYear()
       if (dd < 10) {
         dd = '0' + dd
       }
       if (mm < 10) {
         mm = '0' + mm
       }
       return mm + '-' + dd + '-' + yyyy
     },
     submit () {
       var isValidationFail = false
       for (var index in this.model.dynamicUiData) {
         var model = this.model.dynamicUiData[index]
         if (this.form[model.key] === undefined || this.form[model.key] === '') {
           console.log(this.form[model.key])
           if (model.required) {
             if (model.displayType === 'checkbox') {
               this.form[model.key] = false
             } else {
               this.errorMsg[model.key] = model.key + ' is required'
               isValidationFail = true
               break
             }
           }
         } else {
           this.errorMsg[model.key] = ''
         }
         if (model.validation_type != null) {
           if (!this.validateForm(model.validation_type, this.form[model.key])) {
             this.errorMsg[model.key] = this.VALIDATION_MSG[model.validation_type]
             isValidationFail = true
             break
           } else {
             this.errorMsg[model.key] = ''
           }
         }
       }
       if (!isValidationFail) {
         var payload = {}
         var articleMetadataValues = {}
         var jobFlowMetadataValues = {}
         for (var indexForDate in this.model.dynamicUiData) {
           var modelData = this.model.dynamicUiData[indexForDate]
           if (modelData.displayType === 'datefield') {
             this.form[modelData.key] = this.changeDateFormat(this.form[modelData.key])
             console.log(this.form[modelData.key])
           }
           if (modelData.isjobflowlevel) {
             jobFlowMetadataValues[modelData.key] = this.form[modelData.key]
           } else {
             articleMetadataValues[modelData.key] = this.form[modelData.key]
           }
         }
         payload.sessionid = this.$store.getters.getUserDetails
         payload.status = this.model.status
         payload.jobflowmetadataid = this.model.jobflowmetadataid
         payload.metadataid = this.model.metadataid
         payload['metadata'] = articleMetadataValues
         payload['jobflowmetadata'] = []
         payload['jobflowmetadata'].push({'metadata': jobFlowMetadataValues})
         this.$store.dispatch('notify', payload).then(function () {
           this.model.dynamicMetadataPopupFlag = false
           this.$router.push({name: 'Frozen'})
         }.bind(this))
         .catch(function () {
           this.$store.commit(ERROR_MSG, {
             type: 'error',
             title: this.$t('message.error_popup_page.error'),
             content: this.$t('message.error_popup_page.retry_msg')
           })
         }.bind(this))
       } else {
         var elmnt = document.getElementById(model.key)
         elmnt.scrollIntoView()
       }
     }
   }
}
</script>



// WEBPACK FOOTER //
// DynamicUiForm.vue?22d4d966